<template>
  <section class="section">
    <div class="section-body">
      <div class="card">
        <div class="card-header">
          <v-icon color="#28a745">mdi-file</v-icon>
          <h4>
            {{ $t("messages.report.b5prefix") }}
            {{ $t("messages.report.b5suffix") }}
          </h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.academicYear") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChanged"
                      :selectedVal="selYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.semester") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChanged"
                      :selectedVal="selSemester"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlChanged"
                      :selectedVal="selLvl"
                      :disabled="lvlDisable"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.faculty")
                      }}<code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Faculty
                      :onChanged="onSelFacultyChanged"
                      :selectedVal="selFaculty"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.classCode") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="courseCode"
                              @keypress="handleSearchClsKey($event)"
                            />
                            <button
                              type="button"
                              class="btn btn-temp btn-lg"
                              @click="handleSearchCls(false)"
                            >
                              <i class="fas fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              disabled
                              v-model="courseName"
                            />
                            <button
                              type="button"
                              class="btn btn-danger btn-lg"
                              @click="handleClrCourse()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.section") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select
                        class="form-control"
                        @change="onSelSectionChanged($event)"
                      >
                        <option :selected="selSection == 0" value="0"
                          >---{{
                            $t("messages.general.notSpecified")
                          }}---</option
                        >
                        <option
                          v-for="(item, index) in sections"
                          :key="index"
                          :value="item.SECTION"
                          :selected="selSection == item.SECTION"
                        >
                          {{ item.SECTION }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.report.b5Reporttype") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select
                        class="form-control"
                        @change="onSelReportTypeChanged($event)"
                      >
                        <option :selected="selReportType == 1" value="1">{{
                          $t("messages.general.terms")
                        }}</option>
                        <option :selected="selReportType == 2" value="2">{{
                          $t("messages.general.weeks")
                        }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.selectLang") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select
                        class="form-control"
                        @change="onSelLangChanged($event)"
                      >
                        <option :selected="selLang == 'th'" value="th">{{
                          $t("messages.general.lang.th")
                        }}</option>
                        <option :selected="selLang == 'en'" value="en">{{
                          $t("messages.general.lang.en")
                        }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleClickPrint()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-light btn-lg"
                    @click="handleClearSearchCls()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>

          <v-dialog
            v-model="dialogSearchClass"
            hide-overlay
            scrollable
            max-width="80%"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>search</v-icon>
                <v-toolbar-title>{{
                  $t("messages.general.classList")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogSearchClass = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <form>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.classId") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            <input
                              v-model="dlgSearchClassCourseCode"
                              type="text"
                              class="form-control col mr-2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.className") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            <input
                              v-model="dlgSearchClassCourseName"
                              type="text"
                              class="form-control col mr-2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.faculty") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <Faculty
                            :onChanged="onDlgSearchClassSelFacultyChanged"
                            :selectedVal="dlgSearchClassSelFaculty"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.department") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <Department
                            :onChanged="onDlgSearchClassSelDepartmentChanged"
                            :facultyid="dlgSearchClassSelFaculty"
                            :selectedVal="dlgSearchClassSelDepartment"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.classGroup") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <ClassType
                            :onChanged="onDlgSearchClassSelClsTypeChanged"
                            :selectedVal="dlgSearchClassSelClsType"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{
                            $t("messages.general.educationLvl")
                          }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <Level
                            :onChanged="onDlgSearchClassSelLvlChanged"
                            :selectedVal="dlgSearchClassSelLvl"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-row flex-column justify-content-center align-items-center mt-5"
                  >
                    <div class="form-group">
                      <div class="form-inline">
                        <button
                          type="button"
                          class="btn btn-primary btn-lg"
                          @click="handleSearchCls(true)"
                        >
                          {{ $t("messages.general.search") }}</button
                        >&nbsp;&nbsp;&nbsp;
                        <button
                          type="button"
                          class="btn btn-light btn-lg"
                          @click="handleClearDlgSearchCls()"
                        >
                          {{ $t("messages.general.clearScreen") }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-row text-center">
                    <div class="col no-padding-bottom">
                      <label style="color: red"
                        >{{ $t("messages.general.remarkClickSearch1") }}
                        <v-icon>search</v-icon>
                        {{ $t("messages.general.remarkClickSearch2") }}</label
                      >
                    </div>
                  </div>
                </form>
                <v-card>
                  <b-table
                    bordered
                    hover
                    small
                    responsive
                    caption-top
                    class="table table-striped text-center"
                    :sort-by.sync="bTableSearchCls.sortBy"
                    :sort-desc.sync="bTableSearchCls.sortDesc"
                    :items="bTableSearchCls.items"
                    :fields="bTableSearchCls.fields"
                    :per-page="perPage"
                    :current-page="currentPage"
                  >
                    <template slot="table-caption">
                      <div class="float-left">
                        <b class="mr-2">{{
                          $t("messages.general.table.paginationinfo")
                        }}</b>
                        <b-form-select
                          v-model="perPage"
                          :options="perPageOptions"
                          size="sm"
                          style="width:70px"
                        />
                      </div>
                      <b-pagination
                        class="float-right"
                        size="sm"
                        :total-rows="bTableSearchCls.items.length"
                        v-model="currentPage"
                        :per-page="perPage"
                      />
                      <div
                        v-if="bTableSearchCls.items.length > 0"
                        class="float-right data-table-page-info"
                      >
                        {{
                          Number(
                            currentPage > 1
                              ? (currentPage - 1) * perPage + 1
                              : currentPage
                          ).toLocaleString()
                        }}
                        -
                        {{
                          Number(
                            currentPage * perPage > bTableSearchCls.items.length
                              ? bTableSearchCls.items.length
                              : currentPage * perPage
                          ).toLocaleString()
                        }}
                        {{ $t("messages.general.fromRecords") }}
                        {{
                          Number(bTableSearchCls.items.length).toLocaleString()
                        }}
                      </div>
                      <div
                        v-if="bTableSearchCls.items.length <= 0"
                        class="float-right data-table-page-info"
                      >
                        0 - 0
                        {{ $t("messages.general.fromRecords") }}
                        {{
                          Number(bTableSearchCls.items.length).toLocaleString()
                        }}
                      </div>
                    </template>
                    <!-- 
                    <template v-slot:cell(action)="data">
                      <v-btn
                        text
                        icon
                        @click="openDetail(data.item, data.index)"
                      >
                        <v-icon>search</v-icon>
                      </v-btn>
                    </template> -->

                    <template v-slot:cell(COURSECODE)="data">
                      <a
                        @click="handleSelectClass(data.item, data.index, true)"
                        style="text-decoration: underline;"
                      >
                        {{ data.item.COURSECODE }}
                      </a>
                    </template>

                    <template v-slot:cell(CLASSTIME)="data">
                      <div v-html="data.item.CLASSTIME">
                        {{ data.item.CLASSTIME }}
                      </div>
                    </template>
                  </b-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogError" max-width="600px">
            <v-card tile>
              <v-toolbar flat dense color="red darken-3">
                <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
                <v-toolbar-title style="color: #ffebee;"
                  >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogError = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark color="red accent-1">
                <br />
                <span style="color: red;" v-html="errorText">{{
                  errorText
                }}</span>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ClassProvider from "@/services/class_provider";
import ReportProvider from "@/services/report_provider";

import AcademicYear from "../components/Dropdown/AcademicYear";
import Semester from "../components/Dropdown/Semester";
import Level from "@/components/Dropdown/Level.vue";
import Faculty from "@/components/Dropdown/Faculty.vue";
import Department from "@/components/Dropdown/Department.vue";
import ClassType from "@/components/Dropdown/ClassType.vue";

const classProvider = new ClassProvider();
const reportProvider = new ReportProvider();

export default {
  name: "reportB5",
  components: {
    AcademicYear,
    Semester,
    Level,
    Faculty,
    Department,
    ClassType
  },
  data() {
    return {
      selYear: 0,
      selSemester: 0,
      selLvl: 0,
      selFaculty: 0,
      lvlDisable: false,
      courseId: 0,
      courseCode: "",
      courseName: "",
      courseList: [],
      sections: [],
      selSection: 0,
      selReportType: 1,
      selLang: "th",
      selectClassIdx: 0,
      dialogSearchClass: false,
      dlgSearchClassCourseCode: "",
      dlgSearchClassCourseName: "",
      dlgSearchClassSelFaculty: 0,
      dlgSearchClassSelDepartment: 0,
      dlgSearchClassSelClsType: "",
      dlgSearchClassSelLvl: 3,
      bTableSearchCls: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            sortable: true
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            sortable: true
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true
          },
          {
            key: "SECTION_TEXT",
            label: this.$t("messages.general.section"),
            thClass: "align-middle",
            sortable: true
          },
          {
            key: "COURSEUNIT",
            label: this.$t("messages.general.credit"),
            thClass: "align-middle",
            sortable: true
          },
          {
            key: "GRADEMODE",
            label: this.$t("messages.general.grade"),
            thClass: "align-middle",
            sortable: true
          },
          {
            key: "CLASSTIME",
            label: this.$t("messages.general.classTime"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true
          }
        ]
      },
      perPageOptions: [
        { value: 10, text: 10 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
        { value: 500, text: 500 },
        { value: 1000, text: 1000 },
        { value: 2000, text: 2000 },
        { value: 3000, text: 3000 }
      ],
      perPage: 100,
      currentPage: 1,
      dialogErrorTitle: "",
      dialogError: false,
      errorText: ""
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    }
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
      this.getReportSection();
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
    },
    onSelLvlChanged(event) {
      this.selLvl = parseInt(event.target.value);
    },
    onSelFacultyChanged(event) {
      this.selFaculty = parseInt(event.target.value);
    },
    onSelSectionChanged(event) {
      this.selSection = parseInt(event.target.value);
    },
    onSelReportTypeChanged(event) {
      this.selReportType = parseInt(event.target.value);
    },
    onSelLangChanged(event) {
      this.selLang = event.target.value;
    },
    onDlgSearchClassSelFacultyChanged(event) {
      this.dlgSearchClassSelFaculty = parseInt(event.target.value);
    },
    onDlgSearchClassSelDepartmentChanged(event) {
      this.dlgSearchClassSelDepartment = event.target.value;
    },
    onDlgSearchClassSelClsTypeChanged(event) {
      this.dlgSearchClassSelClsType = event.target.value;
    },
    onDlgSearchClassSelLvlChanged(event) {
      this.dlgSearchClassSelLvl = event.target.value;
    },
    replaceNewLine(data) {
      console.log("replaceNewLine", data);
      return data.toString().replace(/\|/g, "<br />");
    },
    replaceTab(data) {
      return data.toString().replace(/<T>/g, "&emsp;");
    },
    handleClrCourse() {
      this.courseId = 0;
      this.courseCode = "";
      this.courseName = "";
    },
    handleClearDlgSearchCls() {
      this.dlgSearchClassCourseCode = "";
      this.dlgSearchClassCourseName = "";
      this.dlgSearchClassSelFaculty = 0;
      this.dlgSearchClassSelDepartment = 0;
      this.dlgSearchClassSelClsType = "";
      this.dlgSearchClassSelLvl = 3;
      this.bTableSearchCls.items = [];
    },
    async handleSelectClass(item, index, isDlg) {
      this.selectClassIdx = index;
      this.courseId = item.CLASSID;
      this.courseCode = item.COURSECODE;
      this.courseName = item.COURSENAME;
      await this.getReportSection();
      if (isDlg) {
        this.dialogSearchClass = false;
      }
    },
    async handleSearchCls(isDlg) {
      const val = this.courseCode;
      if (val != "" || isDlg) {
        this.togglePreLoader(true);
        const tempRequest = {
          studentid: 0,
          acadyear: this.selYear,
          semester: this.selSemester,
          levelid: isDlg ? this.dlgSearchClassSelLvl : this.selLvl,
          facultyid: isDlg ? this.dlgSearchClassSelFaculty : this.selFaculty,
          coursegroup: isDlg
            ? this.dlgSearchClassSelClsType === "NONE"
              ? ""
              : this.dlgSearchClassSelClsType
            : "",
          structure: null,
          lang: this.currentLang
        };
        const code = isDlg ? this.dlgSearchClassCourseCode : this.courseCode;
        const name = isDlg ? this.dlgSearchClassCourseName : this.courseName;
        if (code != "") {
          tempRequest["coursecode"] = code;
        }
        if (this.courseName != "") {
          tempRequest["coursename"] = name;
        }
        var classTimeReq = {
          token: this.token,
          request: tempRequest
        };
        const data = await classProvider.searchOpenCourse(classTimeReq);
        if (data.length > 0) {
          if (isDlg) {
            this.bTableSearchCls.items = [];
            if (data.length > 0) {
              let idx = 0;
              data.map(d => {
                if (d.CLASSTIME != undefined) {
                  d.CLASSTIME = this.replaceNewLine(d.CLASSTIME);
                }
                d.rowNumber = idx + 1;
                this.bTableSearchCls.items.push(d);
                idx++;
              });
            }
          } else {
            this.handleSelectClass(data[0], 0, false);
            this.courseList = data;
          }
        } else {
          this.handleClrCourse();
          this.dialogSearchClass = true;
        }
        this.togglePreLoader(false);
      } else {
        this.handleClrCourse();
        this.dialogSearchClass = true;
      }
    },
    async getReportSection() {
      if (this.courseCode != "") {
        this.togglePreLoader(true);
        const data = await reportProvider.getReportB5Section({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            courseid: this.courseCode,
            lang: this.currentLang
          }
        });
        this.sections = data;
        this.togglePreLoader(false);
      }
    },
    async handleClickPrint() {
      if (
        this.selYear <= 0 ||
        this.selSemester <= 0 ||
        this.selLvl <= -1 ||
        this.selFaculty <= 0
      ) {
        if (this.selFaculty <= 0) {
          this.dialogErrorTitle = "";
          this.dialogError = true;
          this.errorText = this.$t("messages.general.reqFaculty");
        }
      } else {
        this.togglePreLoader(true);
        const res = await reportProvider.getReportB5({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            levelid: this.selLvl,
            facultyid: this.selFaculty,
            courseid: this.courseCode,
            section: this.selSection,
            reporttype: this.selReportType,
            userid: this.mfuUserId,
            lang: this.selLang
          }
        });
        if (res.status == 200) {
          this.isVisible = false;
          const file = new Blob([res.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          const e = document.createEvent("MouseEvents");
          const a = document.createElement("a");
          a.download = `reportB5.pdf`;
          a.href = fileURL;
          a.dataset.downloadurl = ["application/pdf", a.download, a.href].join(
            ":"
          );
          e.initEvent(
            "click",
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
          );
          a.dispatchEvent(e);
        } else {
          this.dialogErrorTitle = "";
          this.dialogError = true;
          this.errorText = this.$t("messages.checkRegResult.printError");
        }
        this.togglePreLoader(false);
      }
    },
    handleClearSearchCls() {
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
      this.selLvl = 3;
      this.selReportType = 1;
      this.selLang = this.currentLang;
      this.selFaculty = 0;
      this.handleClrCourse();
      this.selSection = 0;
    },
    handleSearchClsKey(event) {
      if (event.charCode == 13) {
        this.handleSearchCls(false);
      }
    }
  },
  mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selLvl = 3;
    this.selReportType = 1;
    this.selLang = this.currentLang;
    this.togglePreLoader(false);
  },
  watch: {
    currentLang(val) {
      this.selLang = val;
      this.bTableSearchCls.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          sortable: true
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          sortable: true
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true
        },
        {
          key: "SECTION_TEXT",
          label: this.$t("messages.general.section"),
          thClass: "align-middle",
          sortable: true
        },
        {
          key: "COURSEUNIT",
          label: this.$t("messages.general.credit"),
          thClass: "align-middle",
          sortable: true
        },
        {
          key: "GRADEMODE",
          label: this.$t("messages.general.grade"),
          thClass: "align-middle",
          sortable: true
        },
        {
          key: "CLASSTIME",
          label: this.$t("messages.general.classTime"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true
        }
      ];
    }
  }
};
</script>
